import { Box, Link } from '@mui/joy';

/** Road-data attribution; links are fixed, never supplied by a chat or URL. */
export default function RouteAttribution({ route }) {
  if (!['ors', 'osrm'].includes(route?.provider)) return null;
  return <Box component="small" sx={{ display: 'flex', flexWrap: 'wrap', columnGap: 1, rowGap: 0.25, mt: 0.5, fontSize: 11, color: 'text.tertiary' }}>
    <Link href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer" level="body-xs">© OpenStreetMap</Link>
    <Link href={route.provider === 'ors' ? 'https://openrouteservice.org/' : 'https://project-osrm.org/'} target="_blank" rel="noopener noreferrer" level="body-xs">
      {route.provider === 'ors' ? 'openrouteservice / HeiGIT' : 'OSRM'}
    </Link>
    <Link href="https://www.openstreetmap.org/fixthemap" target="_blank" rel="noopener noreferrer" level="body-xs">Исправить карту</Link>
  </Box>;
}

